import React, { FC } from 'react'
import { IProps } from './types'
import './styles.scss'

const DropDownButton: FC<IProps> = ({ children, className }) => {
  return (
    <div className={'dropdown ' + className}>
      <button className="button is-primary dropbtn">{children[0]}</button>
      <div className="dropdown-cnt">{children[1]}</div>
    </div>
  )
}

export default DropDownButton
